import { render, staticRenderFns } from "./BetaBanner.vue?vue&type=template&id=524cb76f&scoped=true"
import script from "./BetaBanner.vue?vue&type=script&lang=js"
export * from "./BetaBanner.vue?vue&type=script&lang=js"
import style0 from "./BetaBanner.vue?vue&type=style&index=0&id=524cb76f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524cb76f",
  null
  
)

export default component.exports